<template>
  <div class="airST-conditional-list js-filter-sidebar">
    <div class="airST-conditional-card">
      <div class="airST-conditional-search">
        <p class="airST-conditional-search-title">絞り込み検索</p>
        <p class="airST-conditional-search-detail"></p>
      </div>
      <div v-if="displayFilterLabels.length > 0" class="airST-filter">
        <button type="button" class="airST-filter-all" @click="resetFilter">
          絞り込み条件をクリア
        </button>
        <ul class="airST-filter-list">
          <template v-for="(sf, idx) in displayFilterLabels">
            <li :key="`selected-options-${idx}`" class="airST-filter-list-item">
              <button type="button" @click.prevent="removeFilter(sf)">
                {{ sf.name }}
              </button>
            </li>
          </template>
        </ul>
      </div>
    </div>
    <filter-condition-card
      title="施設名の一部で検索"
      :show="showFilterHotelName"
      @toggle-collapse="showFilterHotelName = !showFilterHotelName"
    >
      <input
        :value="keyWord"
        type="search"
        class="airST-conditional-search-parts-input"
        @keyup="filterHotelName"
      />
    </filter-condition-card>
    <filter-condition-card
      v-for="filterGroup in filterList"
      :key="`condition-card-${filterGroup.code}`"
      :title="filterGroup.name"
      :show="showFilterMap[filterGroup.code]"
      @toggle-collapse="toggleFilterGroup(filterGroup)"
    >
      <template v-for="option in filterGroup.list">
        <div
          v-if="option.view_flag === '1'"
          :key="`option-${filterGroup.code}-${option.code}`"
          class="card_list formControl"
        >
          <input
            :id="`id-${filterGroup.code}-${option.code}`"
            :checked="setSelectedOption(filterGroup.code, option)"
            type="checkbox"
            :value="option.code"
            @change="handleFilters(filterGroup.code, option)"
          />
          <label :for="`id-${filterGroup.code}-${option.code}`">
            {{ option.name }}
          </label>
        </div>
      </template>
    </filter-condition-card>
  </div>
</template>

<script>
import FilterConditionCard from './FilterConditionCard.vue'

const createKey = (group, code) => `${group}:${code}`
const splitKey = (key) => key.split(':')

export default {
  name: 'TkHotelFilter',
  components: {
    FilterConditionCard,
  },
  props: {
    selectedFilterOptions: {
      type: Array,
      default: () => [],
    },
    filterList: {
      type: Array,
      required: true,
    },
    keyWord: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showFilterHotelName: true,
      showFilterMap: {},
    }
  },
  computed: {
    displayFilterLabels() {
      const seen = {}
      const result = []
      for (const filter of this.selectedFilterOptions) {
        if (seen[filter.name] !== 1) {
          seen[filter.name] = 1
          result.push(filter)
        }
      }
      return result
    },
    popularMap() {
      const result = {}
      const popularGroup = this.filterList.filter((g) => g.code === 'popular')
      if (popularGroup && Object.keys(popularGroup).length > 0) {
        for (const fp of popularGroup[0].list) {
          if (fp.populars_sets && Object.keys(fp.populars_sets).length > 0) {
            const popularKey = createKey(popularGroup[0].code, fp.code)
            for (const key of Object.keys(fp.populars_sets)) {
              const mapping = createKey(key, fp.populars_sets[key].join('-'))
              result[popularKey] = mapping
              result[mapping] = popularKey
            }
          }
        }
      }
      return result
    },
    facilityMapping() {
      const facilityGroup = this.filterList.filter((g) => g.code === 'facility')
      const result = {}
      if (facilityGroup && facilityGroup.length > 0) {
        for (const filter of facilityGroup[0].list) {
          result[filter.type] = 'facility'
        }
      }

      return result
    },
    displaySelectedOptions() {
      const display = {}
      for (const option of this.selectedFilterOptions) {
        const selectedGroupCode = this.resolveGroupCode(option.filters_code)
        const selectedCode = option.code
        display[selectedGroupCode] = display[selectedGroupCode] || []
        if (
          !display[selectedGroupCode].find(
            (it) =>
              it.code === selectedCode &&
              (!it.type || it.type === option.filters_code)
          )
        ) {
          display[selectedGroupCode].push({
            code: selectedCode,
            type: option.filters_code,
            filters_code: selectedGroupCode,
          })
        }
        const popularItem = this.popularMap[
          createKey(selectedGroupCode, selectedCode)
        ]
        if (popularItem) {
          const [group, code] = splitKey(popularItem)
          const temp = this.resolveGroupCode(group)
          display[temp] = display[temp] || []
          if (
            !display[temp].find(
              (it) => it.code === code && (!it.type || it.type === group)
            )
          ) {
            display[temp].push({
              code,
              filters_code: temp,
              type: group,
            })
          }
        }
      }
      for (const option of this.filterList) {
        const groupCode = option.code
        if (display[groupCode]) {
          for (const filter of option.list) {
            for (const op of display[groupCode]) {
              if (
                filter.code === op.code &&
                (!filter.type || filter.type === op.type)
              ) {
                op.name = filter.name
                op.type = filter.type
              }
            }
          }
        } else {
          display[groupCode] = []
        }
      }
      return display
    },
  },
  created() {
    const showFilterMap = {}
    this.filterList.forEach((element) => (showFilterMap[element.code] = true))
    this.showFilterMap = { ...showFilterMap }
  },
  methods: {
    toggleFilterGroup(filterGroup) {
      this.showFilterMap = {
        ...this.showFilterMap,
        [filterGroup.code]: !this.showFilterMap[filterGroup.code],
      }
    },
    resolveGroupCode(groupCode) {
      return this.facilityMapping[groupCode] || groupCode
    },
    resetFilter() {
      this.$emit('filter', [])
      this.$emit('filter-name', { hotelName: '' })
    },
    setSelectedOption(group, option) {
      return (
        this.displaySelectedOptions[group].filter(
          (it) =>
            it.code === option.code && (!option.type || it.type === option.type)
        ).length > 0
      )
    },
    filterHotelName(e) {
      this.$emit('filter-name', { hotelName: e.target.value })
    },
    removeFilter(option) {
      const groupCode = option.filters_code
      const facilityGroup = this.facilityMapping[groupCode]
      if (facilityGroup) {
        this.handleFilters(facilityGroup, { ...option, type: groupCode })
      } else {
        this.handleFilters(groupCode, option)
      }
    },
    handleFilters(groupCode, option) {
      const currentSelection = {}
      currentSelection[groupCode] = {
        code: option.code,
        type: option.type,
      }
      const popular = this.popularMap[
        createKey(
          groupCode === 'facility' ? option.type : groupCode,
          option.code
        )
      ]
      if (popular) {
        const [group, code] = splitKey(popular)
        currentSelection[this.resolveGroupCode(group)] = {
          code,
          type: group,
        }
      }
      const selected = []
      for (const group of this.filterList) {
        const oldSelections = this.displaySelectedOptions[group.code] || []
        let selectedOptions = oldSelections.map((o) => ({
          code: o.code,
          type: o.type,
        }))
        const newSelected = currentSelection[group.code]
        if (newSelected) {
          const found = oldSelections.find(
            (it) =>
              it.code === newSelected.code &&
              (!it.type || it.type === newSelected.type)
          )
          if (found) {
            // remove Option
            selectedOptions = selectedOptions.filter(
              (it) =>
                it.code !== newSelected.code ||
                (it.type && it.type !== newSelected.type)
            )
          } else {
            // insert Option
            selectedOptions.push(newSelected)
            this.showFilterMap[group.code] = true
          }
        }
        for (const op of group.list) {
          if (
            selectedOptions.find(
              (o) => o.code === op.code && (!op.type || op.type === o.type)
            )
          ) {
            selected.push({
              filters_code: op.type || group.code,
              code: op.code,
              name: op.name,
              and_or: group.and_or,
              type: 'selection',
            })
          }
        }
      }
      this.$emit('filter', selected)
    },
  },
}
</script>
